export const APP_VERSION = PACKAGE_VERSION + ' : ' + new Date(BUILD_TIMESTAMP).toLocaleDateString();
